import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
//import store from "./store/store";

Vue.use(Router);

const admin_router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "/authentication/login",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        // Application
        {
          name: "Login",
          path: "/authentication/login",
          component: () => import("@/views/authentication/Login"),
          //meta: { guest: true },
        },

        {
          name: "Dashboard",
          path: "/",
          redirect: "/authentication/login",
          component: () => import("@/layouts/full-layout/Layout"),
          children:
            [
              {
                name: "Dashboard",
                path: "dashboard",
                component: () => import("@/views/apps/pages/dashboard"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carriers",
                path: "carrier",
                component: () => import("@/views/apps/pages/carrier"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Detail",
                path: "/carrierdetail/:id",
                component: () => import("@/views/apps/pages/carrierdetail"),
                meta: { requiresAuth: true },
              },           
              {
                name: "Carrier Tariff Detail",
                path: "carriers/carrier_tariffdetail/:id",
                component: () => import("@/views/apps/pages/carriers/carrier_tariffdetail"),
                meta: { requiresAuth: true },
              },            
              {
                name: "Invoices",
                path: "carriers/invoices",
                component: () => import("@/views/apps/pages/carriers/invoices"),
                meta: { requiresAuth: true },
              },
              {
                name: "Invoice",
                path: "invoice",
                component: () => import("@/views/apps/pages/invoice"),
                meta: { requiresAuth: true },
              },
              {
                name: "Master Equivalences",
                path: "/master_equivalences",
                component: () => import("@/views/apps/pages/master_equivalences"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites",
                path: "sites",
                component: () => import("@/views/apps/pages/sites"),
                meta: { requiresAuth: true },
              },
              {
                name: "Countries",
                path: "countries",
                component: () => import("@/views/apps/pages/countries"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites Detail",
                path: "/sitesdetail/:id",
                component: () => import("@/views/apps/pages/sitesdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites Edit",
                path: "/sitesedit/:id",
                component: () => import("@/views/apps/pages/sitesedit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users",
                path: "users",
                component: () => import("@/views/apps/pages/users"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users Detail",
                path: "/usersdetail/:id",
                component: () => import("@/views/apps/pages/usersdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users Edit",
                path: "/usersedit/:id",
                component: () => import("@/views/apps/pages/usersedit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Add File",
                path: "add_file",
                component: () => import("@/views/apps/pages/add_file"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Login",
                path: "carrier_login",
                component: () => import("@/views/apps/pages/carrier_login"),
                meta: { requiresAuth: true },
              },
              {
                name: "Settings",
                path: "settings",
                component: () => import("@/views/apps/pages/settings"),
                meta: { requiresAuth: true },
              },
              {
                name: "Unrecognized Items Monitor",
                path: "/unrecognized-items-monitor",
                component: () => import("@/views/apps/pages/unrecognized_items_monitor"),
                meta: { requiresAuth: true },
              },
            ],

        },
      ],
    },
    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Forget Password",
          path: "forgetpswd",
          component: () => import("@/views/authentication/forgetpswd"),
        },
        {
          name: "Reset Password",
          path: "resetpswd/:id",
          component: () => import("@/views/authentication/resetpswd"),
        },
        {
          name: "Test Login",
          path: "testlogin",
          component: () => import("@/views/authentication/testlogin"),
          //meta: { requiresAuth: true },
        },
        {
          name: "Test Login",
          path: "teststore",
          component: () => import("@/views/authentication/teststore"),
          //meta: { requiresAuth: true },
        },
        {
          name: "Logout",
          path: "logout",
          component: () => import("@/views/authentication/Logout"),
          meta: { requiresAuth: true },
        },
        {
          name: "BoxedLogin",
          path: "boxedlogin",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        {
          name: "FullLogin",
          path: "fulllogin",
          component: () => import("@/views/authentication/FullLogin"),
        },
        {
          name: "BoxedRegister",
          path: "boxedregister",
          component: () => import("@/views/authentication/BoxedRegister"),
        },
        {
          name: "FullRegister",
          path: "fullregister",
          component: () => import("@/views/authentication/FullRegister"),
        },
        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
      ],
    },
    {
      path: "*",
      component: () => import("@/views/authentication/Error"),
    },
  ],
});

import NProgress from "nprogress";

admin_router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

admin_router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

admin_router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated"));

    if (isAuthenticated) {
      next();
      return;
    }
    next("/authentication/login");
  } else {
    next();
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.guest)) {
//     if (store.getters.isAuthenticated) {
//       next("/apps/pages/dashboard");
//       return;
//     }
//     next();
//   } else {
//     next();
//   }
// });

export default admin_router;
